let activeId: string | undefined
let activeClose: (() => void) | undefined

export function openExclusiveConversationMenu(
  id: string,
  open: () => void,
  close: () => void
) {
  if (activeId !== id) {
    activeClose?.()
  }
  activeId = id
  activeClose = close
  open()
}

export function closeExclusiveConversationMenu(id?: string) {
  if (id && activeId !== id) return
  activeClose?.()
  activeId = undefined
  activeClose = undefined
}
